import { useState, useContext } from 'react';
import { Shield, Eye, EyeOff, Save, AlertCircle } from 'lucide-react';
import axios from 'axios';
import AppContext from '../../../../context/AppContext';
import '../../../../assets/css/customer/customerdashboard/customersettings/securitysettings.css';

const SecuritySettings = () => {
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { baseUrl, authToken, validateField} = useContext(AppContext);
  const [passwords, setPasswords] = useState({
    current: '',
    new: '',
    confirm: ''
  });

  const handlePasswordChange = (field, value) => {
    setPasswords(prev => ({ ...prev, [field]: value }));
  };
const handleUpdatePassword = () => {
    const currentErr = !passwords.current ? "Please enter your current password" : "";
    const newErr = validateField('password', passwords.new);
    const confirmErr = !passwords.confirm 
        ? "Please confirm your password" 
        : passwords.new !== passwords.confirm 
        ? "Passwords do not match" 
        : "";

    if (currentErr) { alert(currentErr); return; }
    if (newErr) { alert(newErr); return; }
    if (confirmErr) { alert(confirmErr); return; }

    axios.post(`${baseUrl}/customer/update-password`, {
        current_password: passwords.current,
        new_password: passwords.new,
    }, {
        headers: {
            Authorization: `Bearer ${authToken}`
        }
    })
    .then(response => {
        if (response.data.success) {
            alert('Password updated successfully!');
            setPasswords({ current: '', new: '', confirm: '' });
        } else {
            alert(response.data.message || 'Update failed');
        }
    })
    .catch(error => {
        alert(error.response?.data?.message || 'Failed to update password');
    });
};
  return (
    <div className="cus-sec-container">
      <div className="cus-sec-wrapper">
        <div className="cus-sec-page-header">
          <Shield size={28} className="cus-sec-header-icon" />
          <h2 className="cus-sec-page-title">Privacy & Security</h2>
        </div>

        {/* Change Password*/}
        <div className="cus-sec-settings-card">
          <div className="cus-sec-card-header">
            <Shield size={24} className="cus-sec-card-icon" />
            <h4 className="cus-sec-card-title">Change Password</h4>
          </div>

          <div className="cus-sec-security-alert">
            <AlertCircle size={20} />
            <p>Choose a strong password that you don't use for other accounts. Include letters, numbers, and special characters.</p>
          </div>

          <div className="cus-sec-password-form">
            <div className="cus-sec-form-group">
              <label className="cus-sec-form-label">Current Password</label>
              <div className="cus-sec-password-input-wrapper">
                <input
                  type={showCurrentPassword ? "text" : "password"}
                  className="cus-sec-form-input"
                  placeholder="Enter your current password"
                  value={passwords.current}
                  onChange={(e) => handlePasswordChange('current', e.target.value)}
                />
                <button
                  className="cus-sec-password-toggle"
                  onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                >
                  {showCurrentPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>
            </div>

            <div className="cus-sec-password-row">
              <div className="cus-sec-form-group">
                <label className="cus-sec-form-label">New Password</label>
                <div className="cus-sec-password-input-wrapper">
                  <input
                    type={showNewPassword ? "text" : "password"}
                    className="cus-sec-form-input"
                    placeholder="Enter new password"
                    value={passwords.new}
                    onChange={(e) => handlePasswordChange('new', e.target.value)}
                  />
                  <button
                    className="cus-sec-password-toggle"
                    onClick={() => setShowNewPassword(!showNewPassword)}
                  >
                    {showNewPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                  </button>
                </div>
                {passwords.new && passwords.new.length < 8 && (
                  <span className="cus-sec-password-hint cus-sec-error">Password must be at least 8 characters</span>
                )}
              </div>

              <div className="cus-sec-form-group">
                <label className="cus-sec-form-label">Confirm New Password</label>
                <div className="cus-sec-password-input-wrapper">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    className="cus-sec-form-input"
                    placeholder="Confirm new password"
                    value={passwords.confirm}
                    onChange={(e) => handlePasswordChange('confirm', e.target.value)}
                  />
                  <button
                    className="cus-sec-password-toggle"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    {showConfirmPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                  </button>
                </div>
                {passwords.confirm && passwords.new !== passwords.confirm && (
                  <span className="cus-sec-password-hint cus-sec-error">Passwords do not match</span>
                )}
              </div>
            </div>

            <div className="cus-sec-password-requirements">
              <h6>Password Requirements:</h6>
              <ul>
                <li className={passwords.new.length >= 8 ? 'cus-sec-valid' : ''}>At least 8 characters long</li>
                <li className={/[A-Z]/.test(passwords.new) ? 'cus-sec-valid' : ''}>Contains uppercase letter</li>
                <li className={/[a-z]/.test(passwords.new) ? 'cus-sec-valid' : ''}>Contains lowercase letter</li>
                <li className={/[0-9]/.test(passwords.new) ? 'cus-sec-valid' : ''}>Contains number</li>
                <li className={/[!@#$%^&*]/.test(passwords.new) ? 'cus-sec-valid' : ''}>Contains special character (!@#$%^&*)</li>
              </ul>
            </div>

            <button className="cus-sec-save-button" onClick={handleUpdatePassword}>
              <Save size={18} />
              Update Password
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecuritySettings;